// Generic info card used across Bonuses, VIP, History and Limits views.
// Passthrough wrapper that keeps the Hub .infocard markup consistent.
export default function InfoCard({ gold, className, style, children }) {
  const cls = ["infocard", gold ? "gold" : "", className || ""].filter(Boolean).join(" ");
  return (
    <div className={cls} style={style}>
      {children}
    </div>
  );
}
